import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7d19ee90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share-modal__container" }
const _hoisted_2 = {
  key: 0,
  class: "share-modal__info"
}
const _hoisted_3 = { class: "share-modal__info-url" }
const _hoisted_4 = { class: "share-modal__info-title" }
const _hoisted_5 = { class: "share-modal__info-text" }
const _hoisted_6 = {
  key: 1,
  class: "share-modal__info"
}
const _hoisted_7 = { class: "share-modal__info-title" }
const _hoisted_8 = {
  key: 2,
  class: "share-modal__info"
}
const _hoisted_9 = { class: "share-modal__info-title" }
const _hoisted_10 = {
  key: 3,
  class: "share-modal__publication"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "share-modal__publication-footer" }
const _hoisted_13 = { class: "share-modal__publication-footer-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "share-modal__publication-footer-icon",
  src: "/assets/icon/up-icon.svg",
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "share-modal__publication-footer-value" }
const _hoisted_16 = { class: "share-modal__publication-footer-item" }
const _hoisted_17 = { class: "share-modal__publication-footer-value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-modal__divider" }, null, -1))
const _hoisted_19 = { class: "share-modal__soc-networks" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/copy-link-icon.svg",
  alt: ""
}, null, -1))

import { ref, computed } from 'vue';
import {
  CourseI,
  FeedPublicationI,
  LiteFeedPublicationI,
  TestItemI,
} from '@/types';
import BaseModal from '@/components/modals/BaseModal.vue';
import { IonIcon } from '@ionic/vue';
import { chatboxOutline, shareSocialOutline } from 'ionicons/icons';
import { Clipboard } from '@capacitor/clipboard';
import { Share } from '@capacitor/share';
import { useInternalization } from '@/composables/useInternalization';

interface Props {
  publication?: FeedPublicationI | LiteFeedPublicationI;
  course?: CourseI;
  test?: TestItemI;
  type?: 'post' | 'course' | 'test' | 'expertAdvice';
  isOpened: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareModal',
  props: {
    publication: {},
    course: {},
    test: {},
    type: { default: 'post' },
    isOpened: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useInternalization();

const urlMap = computed(() => ({
  post: `/posts/${props.publication?.publicationId}`,
  course: `/therapy/courses/${props.course?.id}`,
  test: `/therapy-test-view/${props.test?.id}`,
  expertAdvice: '',
}));

const socNetworks = [
  { type: 'whatsapp', image: 'whatsapp.webp' },
  { type: 'twitter', image: 'twitter.svg' },
  { type: 'email', image: 'mail.svg' },
];
const infoApp = {
  url: 'https://www.feelyou.com',
  title:
    "Let's break the stigma surrounding mental health and help those in need.",
  text: 'Check out FeelYou, a free platform that offers support and connects people with similar mental health struggles.',
};
const link = computed(
  () => 'https://app.feelyou.com' + `${urlMap.value[props.type]}`
);
const isCopied = ref(false);

const shareTitle = computed(() => {
  const type = props.type;
  if (type === 'course') {
    return props.course?.title;
  } else if (type === 'post') {
    return props.publication?.title;
  } else if (type === 'test') {
    return props.test?.title;
  } else {
    return props.publication?.title || '';
  }
});

function shareToApps() {
  if (props.type === 'expertAdvice') {
    Share.share(infoApp);
  } else if (props.type === 'course') {
    Share.share({
      url: link.value,
      text: props.course?.title || '',
    });
  } else if (props.type === 'post') {
    Share.share({
      url: link.value,
      text: props.publication?.title || '',
    });
  } else if (props.type === 'test') {
    Share.share({
      url: link.value,
      text: props.test?.title || '',
    });
  }
}

function copyLink() {
  if (props.type === 'expertAdvice') {
    Clipboard.write({
      string: `${infoApp.url} ${infoApp.title} ${infoApp.text}`,
    });
  } else {
    Clipboard.write({
      string: `${link.value}`,
    });
  }
  isCopied.value = true;
}

function close() {
  isCopied.value = false;
  emit('close');
}

return (_ctx: any,_cache: any) => {
  const _component_share_network = _resolveComponent("share-network")!

  return (_openBlock(), _createBlock(BaseModal, {
    title: _unref(t)('share'),
    "is-opened": props.isOpened,
    class: _normalizeClass([
      'share-modal',
      { 'share-modal--expert-advice': props.type === 'expertAdvice' },
    ]),
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.type === 'expertAdvice')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(infoApp.url), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(infoApp.title), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(infoApp.text), 1)
            ]))
          : (props.type === 'course')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(props.course?.title), 1)
              ]))
            : (props.type === 'test')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(props.test?.title), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "share-modal__publication-title",
                    innerHTML: props.publication?.title
                  }, null, 8, _hoisted_11),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, _toDisplayString(props.publication?.reactionsCount || 0), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_unref(IonIcon), {
                        class: "share-modal__publication-footer-icon",
                        icon: _unref(chatboxOutline)
                      }, null, 8, ["icon"]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(props.publication?.commentsCount || 0), 1)
                    ])
                  ])
                ])),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socNetworks, (network) => {
            return _createVNode(_component_share_network, {
              key: network.image,
              network: network.type,
              url: link.value,
              title: shareTitle.value,
              class: "share-modal__soc-network-button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: `/assets/icon/${network.image}`,
                  alt: ""
                }, null, 8, _hoisted_20)
              ]),
              _: 2
            }, 1032, ["network", "url", "title"])
          }), 64))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "share-modal__button share-modal__button--apps",
          onClick: shareToApps
        }, [
          _createVNode(_unref(IonIcon), {
            class: "publication__footer-icon",
            icon: _unref(shareSocialOutline)
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(_unref(t)('shareToApps')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "share-modal__button share-modal__button--link",
          onClick: copyLink
        }, [
          _hoisted_21,
          _createTextVNode(" " + _toDisplayString(isCopied.value ? _unref(t)('copied') : _unref(t)('copyLink')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-opened", "class"]))
}
}

})